import _ from 'lodash';
import qs from 'qs';

import go_api from 'utils/go_api';

export const recordSearchToAnalytics = (keyword) => {
  const trimmed = _.trim(keyword);
  if (!trimmed) return;

  const query = qs.stringify({
    keyword: trimmed,
    analytics: true,
    page_size: 1,
    page: 1,
  });

  go_api.get(`/api/v1/search/results?${query}`).catch(() => {});
};

export default recordSearchToAnalytics;
